<template>
  <AppContent :label="App.MenuMain.SIGNATURES">
    <section class="process-sign">
      <b-tabs
        v-model="activeTab"
        class="block custom-padding tabs-mobile"
        :animated="false"
        role="tablist"
        expanded
        multiline
      >
        <b-tab-item :value="TABS.SIGNING_REQUIRED.value">
          <template slot="header">
            <b-icon icon="note-edit" />
            <span class="tabs-title">
              <label>{{ TABS.SIGNING_REQUIRED.name }}</label>
              <b-tag class="custom-label-fs" rounded>
                {{ getDocumentSignList.count }}
              </b-tag>
            </span>
          </template>

          <SignatureReceived />
        </b-tab-item>

        <b-tab-item :value="TABS.SIGNING_REQUESTED.value">
          <template slot="header">
            <b-icon icon="send" />
            <span class="tabs-title">
              <label>{{ TABS.SIGNING_REQUESTED.name }}</label>
              <b-tag class="custom-label-fs" rounded>
                {{ getDocumentRequestedSignList.count }}
              </b-tag>
            </span>
          </template>

          <SignatureRequested />
        </b-tab-item>

        <b-tab-item :value="TABS.SIGNING_SIGNED.value">
          <template slot="header">
            <b-icon icon="note-check" />
            <span class="tabs-title">
              <label>{{ TABS.SIGNING_SIGNED.name }}</label>
              <b-tag class="custom-label-fs" rounded>
                {{ getDocumentSignedSignList.count }}
              </b-tag>
            </span>
          </template>

          <SignatureAnswered />
        </b-tab-item>
      </b-tabs>
    </section>
  </AppContent>
</template>

<script>
import AppContent from "@/layout/AppContent";

import { App } from "@/utils/constants";
import { PROCESS_SIGNING_FILE_TABS as TABS } from "@/utils/enumerate";
import { mapGetters, mapActions, mapMutations } from "vuex";

import SignatureReceived from "@/components/SignatureReceived.vue";
import SignatureRequested from "@/components/SignatureRequested.vue";
import SignatureAnswered from "@/components/SignatureAnswered.vue";

export default {
  name: "SignaturePanel",

  components: {
    AppContent,
    SignatureReceived,
    SignatureRequested,
    SignatureAnswered
  },
  data() {
    return {
      TABS,
      App
    };
  },

  computed: {
    ...mapGetters({
      getDocumentSignList: "getDocumentSignList",
      getDocumentRequestedSignList: "getDocumentRequestedSignList",
      getDocumentSignedSignList: "getDocumentSignedSignList",
      getCurrentTab: "getCurrentTabSignPanel"
    }),

    activeTab: {
      get() {
        return this.getCurrentTab.value;
      },
      set(value) {
        this.setCurrentTab(this.TABS[value].value);
      }
    },

    actualAction() {
      if (this.activeTab === TABS.SIGNING_REQUIRED.value) {
        return "documentSignRequest";
      } else if (this.activeTab === TABS.SIGNING_REQUESTED.value) {
        return "documentSignRequested";
      } else if (this.activeTab === TABS.SIGNING_SIGNED.value) {
        return "documentSignedRequest";
      }
      return "";
    }
  },

  async beforeMount() {
    await this.initializeData();
  },

  methods: {
    ...mapMutations({
      setCurrentTab: "setCurrentTabSignaturePanel"
    }),
    ...mapActions({
      fileTypes: "fileTypesRequest",
      documentSignRequest: "documentSignRequest",
      documentSignRequested: "documentSignRequested",
      documentSignedRequest: "documentSignedRequest",
      getSignatureBookmarks: "getSignatureBookmarks"
    }),
    async initializeData() {
      this.isLoading = true;
      await Promise.allSettled([this.fileTypes({ state: true })]);
      this.isLoading = false;

      [
        "documentSignRequest",
        "documentSignRequested",
        "documentSignedRequest"
      ].forEach(action => {
        if (action != this.actualAction)
          this.$store.dispatch(action, {
            page: 1,
            only_count: true
          });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.deline-icon > svg {
  height: 75%;
}
.refused {
  text-decoration: underline;
}

.doc-name {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30vw;
  word-break: break-all;
}
.custom-label-fs {
  font-size: 0.7rem;
  margin-left: 5px;
}
</style>
